import React, { Component } from "react";

// layout
import PlainLayout from "../layouts/plain";

// data
import data from "../data.json";

// styles
import "../scss/about.scss";

// image
import bernie from "../img/bernie.003.jpg";

export default class extends Component {
  render() {
    const mini = function(title, list) {
      return (
        <div>
          <h3>{title}</h3>
          <ul>
            {list.map(function(item) {
              if (Array.isArray(item)) {
                return (
                  <li key={item}>
                    <a href={item[1]}>{item[0]}</a>
                  </li>
                );
              } else {
                return <li key={item}>{item}</li>;
              }
            })}
          </ul>
        </div>
      );
    };

    return (
      <PlainLayout>
        <div id="about">
          <img src={bernie} alt="bernie" />
          <h2>Hello, Bernie here&hellip;</h2>
          <div className="story">
            {data.about.map(function(p, i) {
              return <p key={`about${i}`}>{p}</p>;
            })}
          </div>
          <div className="bullets">
            {mini("I'm interested in", data.interests)}
            {mini("I've worked at", data.experience.map(i => i.institution))}
            {mini("I volunteer at", data.volunteer.map(i => i.institution))}
            {mini("I've lived in", data.livedin)}
          </div>
        </div>
      </PlainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/about.js